/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 3.07.24
 *
 */
import BaseObject from "@shared/BaseObject.js";

export default class FeatureDescription extends BaseObject {

	title: string
}
